module.exports = __webpack_public_path__ + "static/img/applets.f81230a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/applets.png
// module id = g20D
// module chunks = 0